import Image from 'next/image'
import React from 'react'

type Props = {
  src: string
  alt: string
  title?: string
  description?: React.ReactNode
  children?: React.ReactNode
  className?: string
  reversed?: boolean
  imageClassName?: string
}

export const HowItWorksStep = ({
  alt,
  src,
  children,
  className,
  description,
  reversed,
  title,
  imageClassName,
}: Props) => {
  return (
    <div
      className={`flex w-full flex-col space-y-6 rounded-lg border border-solid border-cool-300 bg-cool-50 p-6 sm:flex-row sm:space-y-0  sm:p-8  lg:p-10 ${
        reversed && 'sm:flex-row-reverse'
      } ${!reversed && 'sm:space-x-12 lg:space-x-[100px] '} ${className}`}
    >
      {!children && (
        <div
          className={`flex h-full flex-col justify-center ${
            reversed && 'sm:ml-12 lg:ml-[100px]'
          }`}
        >
          <h6 className='mb-4 font-medium sm:hidden'>{title}</h6>
          <h5 className='mb-4 hidden font-medium sm:block lg:hidden'>
            {title}
          </h5>
          <h4 className='mb-4 hidden font-medium lg:block'>{title}</h4>
          {description}
        </div>
      )}
      {children}
      <div className='relative mx-6 flex h-full w-full items-center justify-center self-center bg-warm-50 px-5 py-5 sm:mx-0 sm:min-w-[256px] lg:max-w-[400px] lg:px-0'>
        <div
          className={`relative h-full min-h-[175px] w-full ${imageClassName}`}
        >
          <Image
            src={src}
            alt={alt}
            fill
            loading='lazy'
            fetchPriority='low'
            className='object-contain object-center'
            sizes='(max-width: 639px) 50vw, 30vw'
            quality={60}
          />
        </div>
      </div>
    </div>
  )
}
